module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-container"
  }, [_c('div', {
    staticClass: "head f-flex",
    class: {
      'head-active': _vm.headActive
    }
  }, [_c('div', {
    staticClass: "head-container"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animation),
      expression: "animation"
    }],
    staticClass: "menu-logo",
    attrs: {
      "src": require("../assets/images/ic-menu-y.png")
    },
    on: {
      "click": function($event) {
        return _vm.setScoll()
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.animation),
      expression: "!animation"
    }],
    staticClass: "menu-logo",
    attrs: {
      "src": require("../assets/images/ic-menu.png")
    },
    on: {
      "click": function($event) {
        return _vm.setScoll()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "head-logo",
    attrs: {
      "src": require("../assets/images/ic-logo.png")
    },
    on: {
      "click": function($event) {
        return _vm.onJump('/index', 2)
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animationRight),
      expression: "animationRight"
    }],
    staticClass: "user-logo",
    attrs: {
      "src": require("../assets/images/ic-mine-y.png")
    },
    on: {
      "click": function($event) {
        return _vm.userUp()
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.animationRight),
      expression: "!animationRight"
    }],
    staticClass: "user-logo",
    attrs: {
      "src": require("../assets/images/ic-mine.png")
    },
    on: {
      "click": function($event) {
        return _vm.userUp()
      }
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animation),
      expression: "animation"
    }],
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "link"
  }, _vm._l((_vm.routerLink), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "nav-item",
      attrs: {
        "path": _vm.$route.path,
        "to": item.to
      },
      on: {
        "click": function($event) {
          return _vm.onJump(item.to, item.type)
        }
      }
    }, [_c('span', {
      class: {
        clicked: _vm.$route.path === item.to
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "nav-foot f-flex"
  }, [_c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": require("../assets/images/ic-close.png")
    },
    on: {
      "click": function($event) {
        return _vm.setScoll()
      }
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animationRight),
      expression: "animationRight"
    }],
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "link"
  }, _vm._l((_vm.loginState), function(item, index) {
    return _c('div', {
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          return _vm.onJump(item.to, item.type)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                    ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "nav-foot f-flex"
  }, [_c('img', {
    staticClass: "close-icon",
    attrs: {
      "src": require("../assets/images/ic-close.png")
    },
    on: {
      "click": function($event) {
        return _vm.userUp()
      }
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-712671f4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav-menu.vue
// module id = 697
// module chunks = 17